
import { CaseColumn } from "@/types/caseColumns"
import { DynamicValue } from "@/types/dynamic"
import { DataType, DynamicParameter, DynamicParameterValue, Operator } from "@/types/insights"
import { DateClauseType } from "@/types/insights/dateClauseType"
import { SearchClauseParameters } from "@/types/view"
import { cloneDeep } from "lodash"
import { Component, Vue, Prop } from "vue-property-decorator"

import ParameterValue from "../Controls/ParameterValue.vue"

@Component({
	components: {
		"parameter-value": ParameterValue
	}
})
export default class DynamicParameterValueControl extends Vue {
	@Prop({ default: null })
	dynamicParameter!: DynamicParameter

	@Prop({ default: null })
	value!: DynamicParameterValue | null

	@Prop({ default: [] })
	hideParameters!: DynamicParameter[]

	@Prop({ default: false })
	showCollapsed!: boolean

	get field (): CaseColumn | null {
		return this.dynamicParameter
			? {
				key: this.dynamicParameter.key,
				fieldDataType: this.dateType,
				dataSourceId: this.dynamicParameter.dataSourceId,
				dataType: this.dynamicParameter.dataType === DataType.userRole
					? "user-role"
					: null
			} as CaseColumn
			: null
	}

	get dateType (): DataType {
		return this.dynamicParameter.dataType === DataType.dateRange
			? DataType.dateTime
			: this.dynamicParameter.dataType
	}

	get operator (): Operator | null {
		if (!this.dynamicParameter) {
			return null
		}

		switch (this.dynamicParameter.dataType) {
			case DataType.dateRange:
				return Operator.DateRange
			case DataType.userRole:
				return Operator.Contains
			default:
				return Operator.Equals
		}
	}

	dynamicInput (newDynamic: DynamicValue | null) {
		let value: DynamicParameterValue = this.value
			? cloneDeep(this.value)
			: {
				key: this.dynamicParameter.key,
				dataType: this.dateType,
				value: null,
				dynamicValue: false,
				passValueToParameter: this.dynamicParameter.passValueToParameter,
				isAltered: true
			}

		value.isAltered = this.value?.value.valueOf().toString() !== newDynamic?.value.valueOf().toString()
		value.value = newDynamic ? newDynamic.value : null
		value.dynamicValue = newDynamic && newDynamic.dynamic ? newDynamic.dynamic : false

		this.$emit("input", value)
	}

	paramsChanged (searchParams: SearchClauseParameters) {
		let value: DynamicParameterValue = this.value
			? cloneDeep(this.value)
			: {
				key: this.dynamicParameter.key,
				dataType: this.dateType,
				value: null,
				dynamicValue: false,
				passValueToParameter: this.dynamicParameter.passValueToParameter,
				searchClauseParameters: null,
				isAltered: true
			}
		value.searchClauseParameters = searchParams

		this.$emit("input", value)
	}

	hideParameter (parameter: DynamicParameter) {
		return this.hideParameters.find(p => p.key === parameter.key)
	}
}

